import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "lib/api";
import { useDashboardSettings } from "../settings/store";

const JSON_HEADERS = { "Content-Type": "application/json" };

function jsonRequest(method, payload) {
  if (payload === undefined) return { method };
  return { method, body: JSON.stringify(payload), headers: JSON_HEADERS };
}

export function useCreateDashboardLugar() {
  const s = useDashboardSettings();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (nombre) =>
      api("/dashboard/club/lugares", jsonRequest("POST", { nombre }), { periodoId: s.periodoId }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["dashboard", "actividades-meta"] }),
  });
}

export function usePatchDashboardLugar() {
  const s = useDashboardSettings();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ lugarId, patch }) =>
      api(`/dashboard/club/lugares/${lugarId}`, jsonRequest("PATCH", patch), { periodoId: s.periodoId }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["dashboard", "actividades-meta"] }),
  });
}

export function useDeleteDashboardLugar() {
  const s = useDashboardSettings();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (lugarId) =>
      api(`/dashboard/club/lugares/${lugarId}`, { method: "DELETE" }, { periodoId: s.periodoId }),
    onSuccess: () => Promise.all([
      qc.invalidateQueries({ queryKey: ["dashboard", "actividades-meta"] }),
      qc.invalidateQueries({ queryKey: ["dashboard", "actividades"] }),
    ]),
  });
}

export function useEnrichDashboardLugarFromGoogle() {
  const s = useDashboardSettings();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (lugarId) =>
      api(`/dashboard/club/lugares/${lugarId}/google/enrich`, jsonRequest("POST"), { periodoId: s.periodoId }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["dashboard", "actividades-meta"] }),
  });
}

export function useSearchDashboardGooglePlaces() {
  const s = useDashboardSettings();
  return useMutation({
    mutationFn: (query) =>
      api("/dashboard/club/lugares/google/search", jsonRequest("POST", { query }), { periodoId: s.periodoId }),
  });
}

export function useSelectDashboardGooglePlace() {
  const s = useDashboardSettings();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ lugarId, placeId }) =>
      api(`/dashboard/club/lugares/${lugarId}/google/select`, jsonRequest("POST", { placeId }), {
        periodoId: s.periodoId,
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["dashboard", "actividades-meta"] }),
  });
}

export function useListDashboardGooglePhotos() {
  const s = useDashboardSettings();
  return useMutation({
    mutationFn: (lugarId) =>
      api(`/dashboard/club/lugares/${lugarId}/google/photos`, jsonRequest("POST"), { periodoId: s.periodoId }),
  });
}

export function useSelectDashboardGooglePhoto() {
  const s = useDashboardSettings();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ lugarId, photoName }) =>
      api(`/dashboard/club/lugares/${lugarId}/google/photo`, jsonRequest("POST", { photoName }), {
        periodoId: s.periodoId,
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["dashboard", "actividades-meta"] }),
  });
}
